import React from 'react';
import { useCompanyIcon } from '../../hooks/useCompanyIcon.js';
import { useCompanyName } from '../../hooks/useCompanyName.js';

const OnPowerLogo = ({ className = '', size = 'default', showText = true, textColor = 'text-white' }) => {
  const iconUrl = useCompanyIcon();
  const companyName = useCompanyName();
  const sizeClasses = {
    small: 'w-8 h-8',
    default: 'w-10 h-10',
    medium: 'w-12 h-12',
    large: 'w-16 h-16',
    xl: 'w-20 h-20'
  };

  const textSizes = {
    small: 'text-sm',
    default: 'text-base',
    medium: 'text-lg',
    large: 'text-xl',
    xl: 'text-2xl'
  };

  // Color del texto basado en la imagen proporcionada (negro)
  const getTextColor = () => {
    // Si se especifica explícitamente text-white, mantenerlo (para headers oscuros)
    if (textColor === 'text-white') return 'text-white';
    // Para otros casos, usar negro como solicitado
    return 'text-black';
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {/* Logo de la empresa obtenido desde la API */}
      <div className={`${sizeClasses[size]} flex-shrink-0`}>
        <img
          src={iconUrl || '/generic-logo-white.png'}
          alt="Logo de la empresa"
          className="w-full h-full object-contain"
        />
      </div>
      
      {/* Nombre de la empresa obtenido desde la API */}
      {showText && companyName && (
        <span className={`font-bold ${getTextColor()} ${textSizes[size]}`}>
          {companyName}
        </span>
      )}
    </div>
  );
};

export default OnPowerLogo; 